// dapp metrics
export const USER_ACQUISTION = 'Acquired Users'
export const USER_RETENTION = 'Returning Users'
export const TVL = 'TVL'
export const USERS_THAT_CHURNED = 'Churned Users'
export const MONETIZATION_FEES = 'Fees USD'
export const INTERACTIONS = 'Interactions'
export const TG_GROWTH_INDEX = 'TG Index'
